import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['button', 'menu']

  toggle() {
    this.#isOpen ? this.close() : this.open()
  }

  open() {
    this.buttonTarget.setAttribute('aria-expanded', 'true')
    this.menuTarget.setAttribute('aria-hidden', 'false')
  }

  close() {
    this.buttonTarget.setAttribute('aria-expanded', 'false')
    this.menuTarget.setAttribute('aria-hidden', 'true')
  }

  get #isOpen() {
    return this.menuTarget.getAttribute('aria-hidden') === 'false'
  }
}
